import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getGRNById } from "../../apis/grn";

const GrnItemsDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [grn, setGrn] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) return;
    setLoading(true);

    getGRNById(Number(id))
      .then((res: any) => {
        console.log("GRN Data:", res.data);
        setGrn(res.data);
      })
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="p-4">
      <h1 className="text-xl font-semibold mb-4">GRN Item Details: {id}</h1>

      {loading && <p>Loading...</p>}

      {grn && (
        <>
          <div className="mb-4">
            <p><b>Supplier:</b> {grn.supplier?.name}</p>
            <p><b>Invoice No:</b> {grn.invoiceNumber}</p>
            <p><b>Received On:</b> {grn.receivedDate}</p>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 divide-y divide-gray-300">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Item</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Rec Qty</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Free Qty</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">P Price</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">MRP</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Disc %</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Tax %</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">LC</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">B.No</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">MFG</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">EXP</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {grn.items.map((item: any) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-4 py-5 text-sm text-gray-700">{item.pharmacyItem?.name || "-"}</td>
                    <td className="px-4 py-5 text-sm text-gray-700">{item.receivedQuantity}</td>
                    <td className="px-4 py-5 text-sm text-gray-700">{item.freeQuantity}</td>
                    <td className="px-4 py-5 text-sm text-gray-700">{item.purchasePrice}</td>
                    <td className="px-4 py-5 text-sm text-gray-700">{item.mrp}</td>
                    <td className="px-4 py-5 text-sm text-gray-700">{item.discountPercentage}</td>
                    <td className="px-4 py-5 text-sm text-gray-700">{item.taxPercentage}</td>
                    <td className="px-4 py-5 text-sm text-gray-700">{item.landingCost}</td>
                    <td className="px-4 py-5 text-sm text-gray-700">{item.batchNumber}</td>
                    <td className="px-4 py-5 text-sm text-gray-700">{item.manufacturingDate}</td>
                    <td className="px-4 py-5 text-sm text-gray-700">{item.expiryDate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4">
            <button
              onClick={() => navigate(-1)}
              className="px-4 py-1 bg-white hover:bg-gray-100 rounded border border-gray-600"
            >
              Back
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default GrnItemsDetail;
